import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { mainWebsiteUrl } from "@/mocks/categories";

export default function Hero() {
  const { t } = useTranslation();

  return (
    <section className="relative flex min-h-[640px] w-full items-center justify-center overflow-hidden md:min-h-[720px]">
      <img
        src="https://readdy.ai/api/search-image?query=A%20vibrant%20top%20down%20flat%20lay%20of%20curated%20fashion%20pieces%20including%20a%20pastel%20mint%20sneaker%2C%20a%20peach%20knitted%20hoodie%2C%20round%20gold%20sunglasses%2C%20a%20woven%20straw%20tote%20bag%20and%20a%20small%20glass%20perfume%20bottle%20arranged%20on%20a%20soft%20sage%20green%20surface%2C%20bright%20airy%20studio%20lighting%2C%20fresh%20editorial%20product%20photography%2C%20playful%20yet%20clean%20composition%20with%20pastel%20mint%20and%20warm%20peach%20tones&width=1600&height=900&seq=hero-usfans-1&orientation=landscape&nocache=true"
        alt="USFans Spreadsheet product categories"
        title="USFans Spreadsheet resource hub"
        className="absolute inset-0 h-full w-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/50" />

      <div className="relative z-10 mx-auto w-full max-w-4xl px-4 py-28 text-center md:px-6 md:py-32">
        <p className="mx-auto inline-flex items-center gap-2 rounded-full bg-white/15 px-4 py-1.5 text-xs font-medium text-white backdrop-blur-sm">
          <i className="ri-sparkling-line w-4 h-4 flex items-center justify-center text-sm" />
          {t("hero.eyebrow")}
        </p>

        <h1 className="mt-6 font-heading text-3xl font-bold leading-tight text-white md:text-5xl">
          {t("hero.title")}
        </h1>

        <p className="mx-auto mt-5 max-w-2xl text-sm leading-relaxed text-white/85 md:text-base">
          {t("hero.subtitle")}
        </p>

        <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
          <a
            href={mainWebsiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-7 py-3 text-sm font-semibold text-white transition-colors hover:bg-primary-600 sm:w-auto"
          >
            <i className="ri-grid-line w-4 h-4 flex items-center justify-center text-base" />
            {t("hero.ctaPrimary")}
          </a>
          <a
            href={mainWebsiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-full bg-accent-500 px-7 py-3 text-sm font-semibold text-white transition-colors hover:bg-accent-600 sm:w-auto"
          >
            <i className="ri-shopping-bag-line w-4 h-4 flex items-center justify-center text-base" />
            {t("hero.ctaSecondary")}
          </a>
          <Link
            to="/guide/usfans-spreadsheet-guide"
            className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-full border border-white/40 bg-white/10 px-7 py-3 text-sm font-semibold text-white backdrop-blur-sm transition-colors hover:bg-white/20 sm:w-auto"
          >
            <i className="ri-book-open-line w-4 h-4 flex items-center justify-center text-base" />
            {t("hero.ctaGuide")}
          </Link>
        </div>

        <p className="mt-8 text-xs text-white/70">{t("hero.trust")}</p>
      </div>
    </section>
  );
}